export default {
  decDetail: "https://www.csvw.com/csvw-website/news/skoda-brand-news.html?newsid=2824",
  videoList: {
    //开始参观=》1.开篇824=》弹框2;开始参观=》1.开篇824
    "1": "https://www.csvw.com/u/cms/www/202009/05172802ez0A.mp4",
    //故事模式=》2.湖南话824=》弹框2a;注意事项=》2.湖南话824
    "2": "https://www.csvw.com/u/cms/www/202009/0316514180M4.mp4",
    //体验模式=》3.冲压车间824=》弹框3;参观冲压车间=》3.冲压车间824
    "3": "https://www.csvw.com/csvw/thirdpart/video/3.冲压车间824.mp4",
    // 总装车间=》4.东南西北824=》弹框3a;往哪走？=》4.东南西北824
    "4": "https://www.csvw.com/csvw/thirdpart/video/4.东南西北824.mp4",
    // 车身车间=》5.831车身车间-720P=》弹框4;参观车身车间=》5.831车身车间-720P
    "5": "https://www.csvw.com/csvw/thirdpart/video/5.831车身车间-720P.mp4",
    // 魅夜红=》6.（红）油漆车间824=》弹框5;参观油漆车间（魅夜红）=》6.（红）油漆车间824
    "61": "https://www.csvw.com/csvw/thirdpart/video/6.（红）油漆车间824.mp4",
    // 冰雪白=》6.（白）油漆车间824=》弹框5;参观油漆车间（冰雪白）=》6.（白）油漆车间824
    "62": "https://www.csvw.com/csvw/thirdpart/video/6.（白）油漆车间824.mp4",
    // 非接触光学激光测量=》7.831总装车间_720P=》弹框7;参观总装车间=》7.831总装车间_720P
    "7": "https://www.csvw.com/u/cms/www/202009/03165245O7v3.mp4",
    // 吃个饭先=》8.食堂824=》弹框7a;吃个饭先，去食堂=》8.食堂824
    "8": "https://www.csvw.com/csvw/thirdpart/video/8.食堂824.mp4",
    // 验个车先=》9.质保车间825=》弹框8;验车，去质保=》9.质保车间825
    "9": "https://www.csvw.com/u/cms/www/202009/03165236ba74.mp4",
    // 彩蛋=》10.乘风破826-2=》弹框10;彩蛋=》10.乘风破826-2
    "10": "https://www.csvw.com/csvw/thirdpart/video/10.乘风破826-2.mp4"
  },
}
